import { Component, Input, OnInit, TemplateRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { qmsService } from '../qms.service';
import { messageService } from 'src/app/message.service';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { Router } from '@angular/router';
import { AuService } from '../au/au.service';
import { DocumentViewerComponent } from 'src/app/support/document-viewer/document-viewer.component';
import { DocViewerConfig } from 'src/app/support/models/doc-viewer-config.model';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';


@Component({
  selector: 'app-stageusers',
  templateUrl: './stageusers.component.html',
  styleUrls: ['./stageusers.component.scss']
})
export class StageusersComponent implements OnInit {

  @Input() activityData: any = {};
  isProcessing: boolean = false;
  stageData: any;
  taskStagesList: any = [];
  stageUserList: any[] = [];
  stageUserData: any = {};
  searchValue: string = '';
  operationFlag: any;
  title = "";
  noIfAnyList: any = [];
  anyOrAllList: any = [];
  moduleStagesList: any = [];
  usersList: any = [];
  levels: any = [];
  userRolesList: any = [];
  isShowUserRoleSingle = true;
  isShowLevelSingle = true;
  stage: any;

  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;
  showError: boolean = false;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  visibleAddOrEditStageUserPopup: MatDialogRef<TemplateRef<any>>;
  visibleEditStagePopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteStageUserPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditStageUserPopup', { static: true }) addOrEditStageUserPopup: TemplateRef<any>;
  @ViewChild('editStagePopup', { static: true }) editStagePopup: TemplateRef<any>;
  @ViewChild('deleteStageUserPopup', { static: true }) deleteStageUserPopup: TemplateRef<any>;

  visibleEditCollaborativePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('editCollaborativePopup', { static: true }) editCollaborativePopup: TemplateRef<any>;
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  editStagePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  editCollaborativePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  addOrEditStageUserPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  deleteStageUserPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  event = {
    isUserInput: true,
    source: {
      _selected: true,
    }
  };
  userTxt: any;
  userLevelTxt: any;
  userRoleTxt: any;
  userRoleSearch: any;
  anyOrAllTxt: any;
  noIfAnyTxt: any;
  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  };

  public objectComparisonFunction = function (option: any, value: any): boolean {
    return option.valueExp === value.valueExp;
  };
  constructor(private readonly router: Router, public appService: AppService, private readonly snackBar: MatSnackBar, public paginationService: PaginationService, public dialog: MatDialog, public qmsservice: qmsService, public message: messageService,
    public auService: AuService
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
  }
  @Output() valueChange = new EventEmitter<{ stages: [] }>;

  getIdMethod() {
    let id = this.activityData.workflowId ? this.activityData.workflowId : this.qmsservice.activityId;
    console.log(this.activityData.workflowId, id);
    return id;
  }
  currentUrl: string;

  ngOnInit() {
    this.isProcessing = true;
    this.currentUrl = this.router.url;
    if (this.message.showSwitchUser) {
      this.message.showSwitchUser = true;
    } else {
      this.message.showSwitchUser = false
    }
    this.noIfAnyList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
    this.anyOrAllList = [{ codelistCode: "ANY", codelistName: "Any" }, { codelistCode: "ALL", codelistName: "All" }]
    for (const element of this.noIfAnyList) {
      this.noIfAnyDropdown = this.noIfAnyDropdown.concat({
        valueExp: element,
        displayExp: element
      });
    }
    for (const element of this.anyOrAllList) {
      this.anyOrAllDropdown = this.anyOrAllDropdown.concat({
        valueExp: element.codelistCode,
        displayExp: element.codelistName
      });
    }
    if (this.getIdMethod() != null && this.getIdMethod() != undefined) {
      this.isProcessing = true;
      this.appService.getTaskStages(this.getIdMethod(), 0)
        .subscribe((data: any) => {
          console.log("rev", data);

          // Destructure flags for clarity
          const { phaseIIInvestigationReqd, phaseIIIInvestigationReqd } = this.qmsservice.activity;

          // Filter out Phase II and III stages if their flags are false
          this.taskStagesList = data.filter((stage: any) => {
            const name = stage.stageName;
            const isPhaseII = name === 'PhaseII Review' || name === 'PhaseII Approve';
            const isPhaseIII = name === 'PhaseIII Review' || name === 'PhaseIII Approve';

            // Keep if not PhaseII/III, or if their respective flag is true
            if (isPhaseII && !phaseIIInvestigationReqd) return false;
            if (isPhaseIII && !phaseIIIInvestigationReqd) return false;

            return true;
          });

          // Process each stage
          this.taskStagesList.forEach((stage: any) => {
            if (stage.moduleStagesList?.[0]?.overridable === 'Y') {
              stage.isOverriden = true;
            }
            this.getUsersForStages(stage);
          });

          this.isProcessing = false;
        });


    }
    if (((this.currentUrl == '/dashboard/parallelworkflowDetails' && (this.qmsservice.parallelworkflowStatus == 'Draft' || this.qmsservice.parallelworkflowStatus == 'Review Rejected' || this.qmsservice.parallelworkflowStatus == 'Reviewer Reqd More Info.' || this.qmsservice.parallelworkflowStatus == 'Reviewer Requested More Info.')) &&
      (((this.qmsservice.moduleName == 'CR' || this.qmsservice.moduleName == 'DV' || this.qmsservice.moduleName == 'CAPA') && (this.qmsservice.activity.owner == this.qmsservice.loggeduserid)) ||
        ((this.qmsservice.moduleName == 'IN' || this.qmsservice.moduleName == 'QI' || this.qmsservice.moduleName == 'CC') && (this.qmsservice.activity.evaluator == this.qmsservice.loggeduserid)) ||
        (this.qmsservice.moduleName == 'AU' && (this.qmsservice.activity.leadAuditor == this.qmsservice.loggeduserid))))) {
      this.message.showReviewApproveActionButtons = true;
    } else if (this.qmsservice.moduleName == 'AU' && this.auService.isAuditor
      && (this.qmsservice.activity.status == 'Received Q&A Response' || this.qmsservice.activity.status == 'In Progress/Received Q&A Response' ||
        this.qmsservice.activity.status == 'Inprogress' || this.qmsservice.activity.status == 'Peer Review Rejected' ||
        this.qmsservice.activity.status == 'Peer Reviewer Requested More Info.' || this.qmsservice.activity.status == 'Closure Review Rejected' ||
        this.qmsservice.activity.status == 'Closure Reviewer Requested More Info.' || this.qmsservice.activity.status == 'Closure Approval Rejected' ||
        this.qmsservice.activity.status == 'Closure Approver Requested More Info.')) {
      this.allowAddEdit = true;
    }

  }
  labelName: any;
  allowAddEdit: boolean = false;
  selectedTabValue(event: any) {
    this.labelName = event.tab.textLabel;
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  makeStickyColumns: any;

  dataGridParentCheckBoxChecked(e: any, stage: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      for (const element of stage.taskStageUsersList) {
        element.childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (const element of stage.taskStageUsersList) {
        element.childCheckBoxs = false;
      }
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  downloadTemplates(list: any) {
    let contentData = "data:application/octet-stream;base64," + list.doc;
    let downloadLink = document.createElement("a");
    downloadLink.href = contentData;
    downloadLink.download = list.userRole + "." + list.docExtn;
    downloadLink.click();
  }
  getUsersForStages(stage: any) {
    this.appService.getTaskStageUsers(stage['refNo'], 0, stage['stageName'])
      .subscribe((data: any) => {

        if (data.length > 0) {
          let showrequestedOn = data.filter((x: any) => x.requestedOn != null);
          data[0].showrequestedOn = showrequestedOn.length > 0;

          let showcompletedOn = data.filter((x: any) => x.completedOn != null);
          data[0].showcompletedOn = showcompletedOn.length > 0;

          let showcomments = data.filter((x: any) => x.comments != null);
          data[0].showcomments = showcomments.length > 0;

          let showreasonForSignature = data.filter((x: any) => x.reasonForSignature != null);
          data[0].showreasonForSignature = showreasonForSignature.length > 0;
          stage['taskStageUsersList'] = data;


        } else {
          stage['taskStageUsersList'] = [];
        }
        this.valueChange.emit({ stages: this.taskStagesList });
      })
  }

  editStageFunc(stage: any) {
    this.selectedNoIfAny = [];
    this.selectedNoIfAnyValue = "";
    this.selectedAnyOrAll = [];
    this.selectedAnyOrAllValue = "";
    this.stageData = stage;
    this.selectedNoIfAnyValue = stage.noIfAny;
    this.selectedAnyOrAllValue = stage.anyOrAll;
    if (stage.noIfAny) {
      for (const element of this.noIfAnyDropdown) {
        if (element.valueExp == stage.noIfAny) {
          this.selectedNoIfAny = element.valueExp;
        }
      }
    } else {
      this.selectedNoIfAny = '';
    }
    if (stage.anyOrAll) {
      for (const element of this.anyOrAllDropdown) {
        if (element.valueExp == stage.anyOrAll) {
          this.selectedAnyOrAll = element.valueExp;
        }
      }
    } else {
      this.selectedAnyOrAll = '';
    }
    this.visibleEditStagePopup = this.dialog.open(this.editStagePopup, this.editStagePopupConfig);
  }

  editCollaborativeFunc(stage: any) {
    this.selectedNoIfAny = [];
    this.selectedNoIfAnyValue = "";
    this.selectedAnyOrAll = [];
    this.selectedAnyOrAllValue = "";
    this.stageData = stage;
    this.selectedNoIfAnyValue = stage.noIfAny;
    this.selectedAnyOrAllValue = stage.anyOrAll;
    if (stage.noIfAny) {
      for (const element of this.noIfAnyDropdown) {
        if (element.valueExp == stage.noIfAny) {
          this.selectedNoIfAny = element.valueExp;
        }
      }
    } else {
      this.selectedNoIfAny = '';
    }
    if (stage.anyOrAll) {
      for (const element of this.anyOrAllDropdown) {
        if (element.valueExp == stage.anyOrAll) {
          this.selectedAnyOrAll = element.valueExp;
        }
      }
    } else {
      this.selectedAnyOrAll = '';
    }
    this.visibleEditCollaborativePopup = this.dialog.open(this.editCollaborativePopup, this.editCollaborativePopupConfig);
  }

  addStageUserFunc(stage: any) {
    this.stageData = stage;
    this.stageUserData['userId'] = "";
    this.stageUserData['userLevel'] = "";
    this.stageUserData['taskStageUserId'] = "";
    this.selectedUserValue = "";
    this.selectedUserRoleValue = "";
    this.selectedLevelValue = "";
    this.selectedLevel = null;
    this.selectedUser = null;
    this.selectedUserRole = null;
    this.userDropdown = [];
    this.levelDropdown = [];
    this.userRoleDropdown = [];
    this.isProcessing = true;
    console.log(stage);
    this.appService.getModuleStages(stage['module'], stage['stageName'])
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.moduleStagesList = data;
        if (this.moduleStagesList[0]['userRoles'] != null) {
          if (stage.module == "PRL_WORKFLOW" && this.qmsservice.moduleName == 'AU') {
            this.userRolesList = ["Peer Reviewer"]
          } else {
            this.userRolesList = this.moduleStagesList[0]['userRoles'].split(",");
          }

          if (this.userRolesList.length > 0 && this.userRolesList.length == 1 && !(stage.module == "PRL_WORKFLOW" && this.qmsservice.moduleName == 'AU')) {
            this.isShowUserRoleSingle = true;
            this.selectedUserRoleValue = this.userRolesList[0];
          } else if (this.userRolesList.length > 1 || (stage.module == "PRL_WORKFLOW" && this.qmsservice.moduleName == 'AU')) {
            this.isShowUserRoleSingle = false;
            for (const element of this.userRolesList) {
              this.userRoleDropdown = this.userRoleDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
        }
        if (this.moduleStagesList[0]['noOfLevels']) {
          if (this.moduleStagesList[0]['noOfLevels'] == 1) {
            this.isShowLevelSingle = true;
            this.selectedLevelValue = 1;
          } else {
            let j = 1;
            while (j > this.moduleStagesList[0]['noOfLevels']) {
              this.levels.push(j);
              j++;
            }
            this.isShowLevelSingle = false;
            for (const element of this.levels) {
              this.levelDropdown = this.levelDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
        } else {
          this.levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
          this.isShowLevelSingle = false;
          for (const element of this.levels) {
            this.levelDropdown = this.levelDropdown.concat({
              valueExp: element,
              displayExp: element
            });
          }
        }
      })
    this.isProcessing = true;
    this.stage = "";
    if (this.stageData.stageName == "Closure Approve" || this.stageData.stageName == "Approve" || this.stageData.stageName == "PhaseII Approve" || this.stageData.stageName == "PhaseIII Approve") {
      this.stage = this.stageData.stageName + "r";
    } else {
      this.stage = this.stageData.stageName + "er";
    }

    this.stage == "PhaseII Reviewer" && (this.stage = 'Reviewer')
    this.stage == "PhaseII Approver" && (this.stage = 'Approver')
    this.stage == "PhaseIII Reviewer" && (this.stage = 'Reviewer')
    this.stage == "PhaseIII Approver" && (this.stage = 'Approver')
    this.appService.getQmsActiveGroupUsers(this.qmsservice.activity.groupId, this.qmsservice.moduleName, this.stage).subscribe((data: any) => {
      this.usersList = data;
      this.isProcessing = false;
      for (const element of this.usersList) {
        this.userDropdown = this.userDropdown.concat({
          valueExp: element.userId,
          displayExp: element.userName
        });
      }
    });

    this.stageUserData['module'] = stage['module'];
    this.stageUserData['refNo'] = stage['refNo'];
    this.stageUserData['refDetails'] = stage['refDetails'];
    this.stageUserData['stageName'] = stage['stageName'];
    this.stageUserData['version'] = stage['version'];
    this.operationFlag = "ADD";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.title = 'Create ' + stage.stageName;
    this.visibleAddOrEditStageUserPopup = this.dialog.open(this.addOrEditStageUserPopup, this.addOrEditStageUserPopupConfig);
  }

  isUserOdd: any = null;
  isUserRoleOdd: any = null;
  editStageUserFunc(stage: any, user: any) {
    this.isProcessing = true;
    this.stageData = stage;
    this.stageUserData = user;
    this.userDropdown = [];
    this.levelDropdown = [];
    this.userRoleDropdown = [];
    this.selectedLevel = null;
    this.selectedLevelValue = "";
    this.selectedUser = null;
    this.selectedUserValue = "";
    this.selectedUserRole = null;
    this.selectedUserRoleValue = "";
    console.log(this.stageData.taskStageUsersList[0].taskStageUsersPk.userId);
    this.selectedUser = user.taskStageUsersPk.userId;
    this.appService.getModuleStages(stage['module'], stage['stageName'])
      .subscribe((data: any) => {
        this.moduleStagesList = data;
        if (this.moduleStagesList[0]['userRoles'] != null) {
          if (stage.module == "PRL_WORKFLOW" && this.qmsservice.moduleName == 'AU') {
            this.userRolesList = ["Peer Reviewer"]
          } else {
            this.userRolesList = this.moduleStagesList[0]['userRoles'].split(",");
          }
          if (this.userRolesList.length > 0 && this.userRolesList.length == 1 && !(stage.module == "PRL_WORKFLOW" && this.qmsservice.moduleName == 'AU')) {
            this.isShowUserRoleSingle = true;
            this.selectedUserRoleValue = this.userRolesList[0];
          } else if (this.userRolesList.length > 1 || (stage.module == "PRL_WORKFLOW" && this.qmsservice.moduleName == 'AU')) {
            this.isShowUserRoleSingle = false;
            for (const element of this.userRolesList) {
              this.userRoleDropdown = this.userRoleDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
          if (stage.module == "PRL_WORKFLOW" && this.qmsservice.moduleName == 'AU') {
            this.onUserRoleSelect(this.event, this.userRoleDropdown[0]);
          }
        }
        if (this.moduleStagesList[0]['noOfLevels']) {
          if (this.moduleStagesList[0]['noOfLevels'] == 1) {
            this.isShowLevelSingle = true;
            this.selectedLevelValue = 1;
          } else {
            let j = 1;
            while (j > this.moduleStagesList[0]['noOfLevels']) {
              this.levels.push(j);
              j++;
            }
            this.isShowLevelSingle = false;
            for (const element of this.levels) {
              this.levelDropdown = this.levelDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
        } else {
          this.levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
          this.isShowLevelSingle = false;
          for (const element of this.levels) {
            this.levelDropdown = this.levelDropdown.concat({
              valueExp: element,
              displayExp: element
            });
          }
        }

        if (user.userRole != null) {
          for (const element of this.userRoleDropdown) {
            if (element.valueExp == user.userRole) {
              this.selectedUserRole = element.valueExp;
            }
          }
        }
        if (user.userLevel != null) {
          for (const element of this.levelDropdown) {
            if (element.valueExp == user.userLevel) {
              this.selectedLevel = element.valueExp;
            }
          }
        }
        this.stage = "";
        if (this.stageData.stageName == "Closure Approve" || this.stageData.stageName == "Approve") {
          this.stage = this.stageData.stageName + "r";
        } else {
          this.stage = this.stageData.stageName + "er";
        }
        this.stage == "PhaseII Reviewer" && (this.stage = 'Reviewer')
        this.stage == "PhaseII Approver" && (this.stage = 'Approver')
        this.stage == "PhaseIII Reviewer" && (this.stage = 'Reviewer')
        this.stage == "PhaseIII Approver" && (this.stage = 'Approver')
        this.appService.getQmsActiveGroupUsers(this.qmsservice.activity.groupId, this.qmsservice.moduleName, stage.module == "PRL_WORKFLOW" ? user.userRole : this.stage).subscribe((data: any) => {
          this.usersList = data;
          for (const element of this.usersList) {
            this.userDropdown = this.userDropdown.concat({
              valueExp: element.userId,
              displayExp: element.userName
            });
          }
          if (user.taskStageUsersPk.userId != null) {
            let usersValues = this.userDropdown.filter((x: any) => x.valueExp === user.taskStageUsersPk.userId);
            if (usersValues.length > 0) {
              this.selectedUser = usersValues[0].valueExp;
              this.isUserOdd = null;
            } else {
              this.userDropdown.push({
                valueExp: user.taskStageUsersPk.userId,
                displayExp: user.userName
              })
              this.selectedUser = this.isUserOdd = user.taskStageUsersPk.userId;
            }
          }
          this.isProcessing = false;
        })
      })

    this.stage = "";
    if (this.stageData.stageName == "Approve" || this.stageData.stageName == "Closure Approve") {
      this.stage = this.stageData.stageName + "r";
    } else if (this.stageData.stageName == "Review" || this.stageData.stageName == "Closure Review") {
      this.stage = this.stageData.stageName + "er";
    }

    this.stageUserData['module'] = stage['module'];
    this.stageUserData['refNo'] = stage['refNo'];
    this.stageUserData['refDetails'] = stage['refDetails'];
    this.stageUserData['stageName'] = stage['stageName'];
    this.stageUserData['version'] = stage['version'];
    this.stageUserData['slNo'] = user.taskStageUsersPk.slNo;
    this.selectedUserValue = user.taskStageUsersPk.userId;
    this.selectedLevelValue = user.userLevel;
    this.selectedUserRoleValue = user.userRole;
    this.operationFlag = "EDIT";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.title = 'Update ' + stage.stageName;
    this.visibleAddOrEditStageUserPopup = this.dialog.open(this.addOrEditStageUserPopup, this.addOrEditStageUserPopupConfig);
  }


  deleteStageUserFunc(stage: any, user: any) {
    this.stageUserData = user;
    this.stageData = stage;
    this.stageUserData['deleteReason'] = "";
    this.stageUserData['module'] = stage['module'];
    this.stageUserData['refNo'] = stage['refNo'];
    this.stageUserData['refDetails'] = stage['refDetails'];
    this.stageUserData['stageName'] = stage['stageName'];
    this.stageUserData['version'] = stage['version'];
    this.stageUserData['slNo'] = user.taskStageUsersPk.slNo;
    this.stageUserData['userId'] = user.taskStageUsersPk.userId;
    this.title = 'Delete ' + stage.stageName;
    this.visibleDeleteStageUserPopup = this.dialog.open(this.deleteStageUserPopup, this.deleteStageUserPopupConfig);
  }

  cancelAddAndEditStageUserFunction() {
    this.visibleAddOrEditStageUserPopup.close();
  }

  cancelAddAndEditFunction() {
    this.visibleEditStagePopup.close();
  }
  cancelAddAndEditCollaborativeFunction() {
    this.visibleEditCollaborativePopup.close();
  }
  selectedNoIfAny: any = [];
  noIfAnyDropdown: any = [];
  selectedNoIfAnyValue: any;

  selectedAnyOrAll: any = [];
  anyOrAllDropdown: any = [];
  selectedAnyOrAllValue: any;

  selectedUser: any = [];
  userDropdown: any = [];
  selectedUserValue: any;

  selectedLevel: any = [];
  levelDropdown: any = [];
  selectedLevelValue: any;

  selectedUserRole: any = [];
  userRoleDropdown: any = [];
  selectedUserRoleValue: any;

  onNoIfAnySelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedNoIfAnyValue = item.valueExp;
      }
    }
  }

  onNoIfAnyRemoved(item: any) {
    this.selectedNoIfAnyValue = "";
  }

  onAnyOrAllSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedAnyOrAllValue = item.valueExp;
        if (this.selectedAnyOrAllValue == "ALL") {
          this.selectedNoIfAnyValue = "";
        }
      }
    }
  }

  onAnyOrAllRemoved(item: any) {
    this.selectedAnyOrAllValue = "";
  }

  onUserSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedUserValue = item.valueExp;
      }
    }
  }

  onUserRemoved(item: any) {
    this.selectedUserValue = "";
  }

  onLevelSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedLevelValue = item.valueExp;
      }
    }
  }

  onLevelRemoved(item: any) {
    this.selectedLevelValue = "";
  }

  onUserRoleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedUserRoleValue = item.valueExp;
        this.userDropdown = [];
        this.selectedUser = this.operationFlag == 'ADD' ? [] : "";
        if (this.stageUserData.taskStageUsersPk != undefined) {
          this.stageUserData.taskStageUsersPk.userId = null;
        }

        this.getAllModuleStageUsersList(this.selectedUserRoleValue);
      }
    }
  }

  onUserRoleRemoved(item: any) {
    this.selectedUserRoleValue = "";
  }

  getAllModuleStageUsersList(stage: any) {
    this.usersList = [];
    this.appService.getQmsActiveGroupUsers(this.qmsservice.activity.groupId, this.qmsservice.moduleName, stage).subscribe((data: any) => {
      this.usersList = data;
      for (const element of this.usersList) {
        this.userDropdown = this.userDropdown.concat({
          valueExp: element.userId,
          displayExp: element.userName
        });
      }
    });
  }

  addAndEditFunction(stage: any) {
    this.isProcessing = true;
    delete stage['updatedOn'];
    stage['noIfAny'] = this.selectedNoIfAnyValue;
    stage['anyOrAll'] = this.selectedAnyOrAllValue;
    this.appService.updateTaskStage(stage).subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.visibleEditStagePopup.close();
          this.isProcessing = true;
          this.appService.getTaskStages(this.getIdMethod(), 0)
            .subscribe((data: any) => {
              this.taskStagesList = data;
              for (const element of this.taskStagesList) {
                if (element.moduleStagesList.length > 0) {
                  if (element.moduleStagesList[0].overridable == "Y") {
                    element.isOverriden = true;
                  }
                }
                this.getUsersForStages(element);
              }
              this.isProcessing = false;
            })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {

          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      }
    });
  }

  addAndEditCollaborativeFunction(stage: any) {
    this.isProcessing = true;
    delete stage['updatedOn'];
    delete stage['completedOn'];
    delete stage['requestedOn'];
    stage['noIfAny'] = this.selectedNoIfAnyValue;
    stage['anyOrAll'] = this.selectedAnyOrAllValue;
    stage['userLevel'] = this.stageData.userLevel;
    stage['version'] = 0;
    stage['refNo'] = this.stageData.taskStageUsersPk.refNo;
    stage['module'] = this.stageData.module;
    stage['stageName'] = this.stageData.taskStageUsersPk.stageName;
    console.log(stage);

    this.appService.addTaskStageCollaborative(stage).subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.visibleEditCollaborativePopup.close();
          this.isProcessing = true;
          this.appService.getTaskStages(this.getIdMethod(), 0)
            .subscribe((data: any) => {
              this.taskStagesList = data;
              for (const element of this.taskStagesList) {
                if (element.moduleStagesList.length > 0) {
                  if (element.moduleStagesList[0].overridable == "Y") {
                    element.isOverriden = true;
                  }
                }
                this.getUsersForStages(element);
              }
              this.isProcessing = false;
            })
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {

          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      }
    });
  }

  addAndEditStageUserFunction(stageUserData: any) {
    this.isProcessing = true;
    if (!this.selectedUserValue || !this.selectedLevelValue) {
      this.showError = true;
      this.isProcessing = false;
    } else {
      this.showError = false;
      if (this.operationFlag == "ADD") {

        if (stageUserData['updatedOn'] != null) {
          delete stageUserData['updatedOn'];
        }

        if (stageUserData['completedOn'] != null) {
          delete stageUserData['completedOn'];
        }

        stageUserData['userId'] = this.selectedUserValue;
        stageUserData['userLevel'] = this.selectedLevelValue;
        stageUserData['userRole'] = this.selectedUserRoleValue;
        this.appService.addTaskStageUser(stageUserData).subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              if (this.visibleAddOrEditStageUserPopup != undefined) {
                this.visibleAddOrEditStageUserPopup.close();
              }
              this.getUsersForStages(this.stageData);
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {

              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        delete stageUserData['updatedOn'];
        stageUserData['userId'] = this.selectedUserValue;
        stageUserData['userLevel'] = this.selectedLevelValue;
        stageUserData['userRole'] = this.selectedUserRoleValue;
        if (stageUserData['completedOn'] != null) {
          stageUserData['completedOn'] = new Date(stageUserData['completedOn']);
        }
        if (stageUserData['requestedOn'] != null) {
          stageUserData['requestedOn'] = new Date(stageUserData['requestedOn']);
        }
        this.appService.updateTaskStageUser(stageUserData).subscribe({
          next: (data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              if (this.visibleAddOrEditStageUserPopup != undefined) {
                this.visibleAddOrEditStageUserPopup.close();
              };
              this.getUsersForStages(this.stageData);
              if (!this.title) {
                this.switchuserComponent.cancelSwitchUserPopup();
                this.switchuserComponent.closeConfirmationPopup();
                this.switchuserComponent.saveMethod();
              }
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              data: {
                message: data.result,
                type: data.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: data.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  deleteReasonFieldValue: any;
  deleteValidation() {
    this.deleteReasonFieldValue = document.getElementById('deleteReason-validation') as HTMLInputElement;
    if (this.deleteFiledValue.value == '') {
      this.isProcessing = false;
      this.deleteReasonFieldValue.style.color = 'red';
    } else {
      this.deleteReasonFieldValue.style.color = '';
    }
  }

  onFieldFocusout() {
    if (this.deleteReasonFieldValue != undefined) {
      if (this.stageUserData.deleteReason == "" || this.stageUserData.deleteReason == undefined) {
        this.deleteReasonFieldValue.style.color = 'red';
      } else {
        this.deleteReasonFieldValue.style.color = '';
      }
    }
  }

  deleteFiledValue: any;
  deleteFunction() {
    this.isProcessing = true;
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    if (this.deleteFiledValue.value == "") {
      this.deleteValidation();
      alert('Please enter the mandatory fields...');
      this.isProcessing = false;
    } else {
      delete this.stageUserData['updatedOn'];
      if (this.stageUserData['completedOn'] != null) {
        delete this.stageUserData['completedOn'];
      }
      if (this.stageUserData['requestedOn'] != null) {
        delete this.stageUserData['requestedOn'];
      }


      this.appService.deleteTaskStageUser(this.stageUserData).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleDeleteStageUserPopup.close();
            this.getUsersForStages(this.stageData);
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {

            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeleteStageUserPopup.close();
  }

  @ViewChild(DocumentViewerComponent) documentViewerComponent!: DocumentViewerComponent;
  docViewer!: DocViewerConfig;


  downloadDocuments(list: any) {
    this.isProcessing = true;
    console.log("list", list);
    try {
      const contentType = this.appService.getContentTypeByExtension(list.docExtn);
      const blob = this.appService.base64ToBlob(list.doc, contentType);;

      const doc = {
        body: blob,
        contentType: contentType,
        extn: list.docExtn
      };

      this.docViewer = {
        blob,
        doc,
        docName: list.userRole + " " + 'Document',
        docExtension: list.docExtn
      };

      setTimeout(() => {
        this.documentViewerComponent?.openPopUp();
      }, 0);

    } catch (err) {
      console.error('Error while decoding or preparing document:', err);
      alert('Failed to load document.');
    } finally {
      this.isProcessing = false;
    }
  }

  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;
  openswitchuser(value: any, stage: any, user: any) {
    this.message.switchedUser = null;
    this.message.switchUserdropDownList = [];
    this.message.submodule = "StageUsers";
    this.message.switchuserRole = value;
    this.isProcessing = true;
    this.stageData = stage;
    this.stageUserData = user;
    this.userDropdown = [];
    this.levelDropdown = [];
    this.userRoleDropdown = [];
    this.selectedLevel = [];
    this.selectedLevelValue = "";
    this.selectedUser = [];
    this.selectedUserValue = "";
    this.selectedUserRole = [];
    this.selectedUserRoleValue = "";
    this.title = '';

    this.appService.getModuleStages(stage['module'], stage['stageName'])
      .subscribe((data: any) => {
        this.moduleStagesList = data;
        if (this.moduleStagesList[0]['userRoles'] != null) {
          this.userRolesList = this.moduleStagesList[0]['userRoles'].split(",");
          if (this.userRolesList.length > 0 && this.userRolesList.length == 1) {
            this.isShowUserRoleSingle = true;
            this.selectedUserRoleValue = this.userRolesList[0];
          } else if (this.userRolesList.length > 1) {
            this.isShowUserRoleSingle = false;
            for (const element of this.userRolesList) {
              this.userRoleDropdown = this.userRoleDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
        }
        if (this.moduleStagesList[0]['noOfLevels']) {
          if (this.moduleStagesList[0]['noOfLevels'] == 1) {
            this.isShowLevelSingle = true;
            this.selectedLevelValue = 1;
          } else {
            let j = 1;
            while (j > this.moduleStagesList[0]['noOfLevels']) {
              this.levels.push(j);
              j++;
            }
            this.isShowLevelSingle = false;
            for (const element of this.levels) {
              this.levelDropdown = this.levelDropdown.concat({
                valueExp: element,
                displayExp: element
              });
            }
          }
        } else {
          this.levels = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
          this.isShowLevelSingle = false;
          for (const element of this.levels) {
            this.levelDropdown = this.levelDropdown.concat({
              valueExp: element,
              displayExp: element
            });
          }
        }

        if (user.userRole != null) {
          for (const element of this.userRoleDropdown) {
            if (element.valueExp == user.userRole) {
              this.selectedUserRole = [{
                valueExp: element.valueExp,
                displayExp: element.displayExp
              }]
            }
          }
        }
        if (user.userLevel != null) {
          for (const element of this.levelDropdown) {
            if (element.valueExp == user.userLevel) {
              this.selectedLevel = element.valueExp;
            }
          }
        }
        this.stage = "";
        if (this.stageData.stageName == "Closure Approve" || this.stageData.stageName == "PhaseII Approve" || this.stageData.stageName == "PhaseIII Approve" || this.stageData.stageName == "Approve") {
          this.stage = this.stageData.stageName + "r";
        } else {
          this.stage = this.stageData.stageName + "er";
        }
        if (this.stageData.stageName == "Parallel Workflow Approve" || this.stageData.stageName == "PhaseII Approve" || this.stageData.stageName == "PhaseIII Approve" || this.stageData.stageName == "Parallel Workflow Review") {
          this.stage = user.userRole
        }
        this.stage == "PhaseII Reviewer" && (this.stage = 'Reviewer')
        this.stage == "PhaseII Approver" && (this.stage = 'Approver')
        this.stage == "PhaseIII Reviewer" && (this.stage = 'Reviewer')
        this.stage == "PhaseIII Approver" && (this.stage = 'Approver')
        this.appService.getQmsActiveGroupUsers(this.qmsservice.activity.groupId, this.qmsservice.moduleName, this.stage).subscribe((data: any) => {
          this.usersList = data;
          for (const element of this.usersList) {
            this.userDropdown = this.userDropdown.concat({
              valueExp: element.userId,
              displayExp: element.userName
            });
          }
          this.message.switchUserdropDownList = this.userDropdown;
          if (user.taskStageUsersPk.userId != null) {
            let usersValues = this.usersList.filter((x: any) => x.userId === user.taskStageUsersPk.userId);
            if (usersValues.length > 0) {
              this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = usersValues[0].userId
            } else {
              this.userDropdown.push({
                valueExp: user.taskStageUsersPk.userId,
                displayExp: user.userName
              })
              this.message.currentSwitchuser = this.message.switchedUser = this.selectedUser = user.taskStageUsersPk.userId
            }
          }

          this.isProcessing = false;
        })
      })

    this.stage = "";
    if (this.stageData.stageName == "Approve" || this.stageData.stageName == "PhaseII Approve" || this.stageData.stageName == "PhaseIII Approve" || this.stageData.stageName == "Closure Approve" || this.stageData.stageName == "Parallel Workflow Approve") {
      this.stage = this.stageData.stageName + "r";
    } else if (this.stageData.stageName == "Review" || this.stageData.stageName == "PhaseII Review" || this.stageData.stageName == "PhaseIII Review" || this.stageData.stageName == "Peer Review" || this.stageData.stageName == "Closure Review" || this.stageData.stageName == "Parallel Workflow Review") {
      this.stage = this.stageData.stageName + "er";
    }

    this.stageUserData['module'] = stage['module'];
    this.stageUserData['refNo'] = stage['refNo'];
    this.stageUserData['refDetails'] = stage['refDetails'];
    this.stageUserData['stageName'] = stage['stageName'];
    this.stageUserData['version'] = stage['version'];
    this.stageUserData['slNo'] = user.taskStageUsersPk.slNo;
    this.message.switchUserCurrentValue = user.taskStageUsersPk.userId;
    this.selectedUserValue = user.taskStageUsersPk.userId;
    this.selectedLevelValue = user.userLevel;
    this.selectedUserRoleValue = user.userRole;
    this.operationFlag = "EDIT";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.switchuserComponent.openswitchuser(this.stage, 'SU');
  };
  onChildValueEmitted() {
    this.message.currentSwitchuser = this.selectedUserValue = this.message.switchedUser ?? null;
    this.addAndEditStageUserFunction(this.stageUserData);
  }

  idMapping: Record<string, string> = { 'CR': this.qmsservice.activity.crId, 'CAPA': this.qmsservice.activity.capaId, 'DV': this.qmsservice.activity.dvId, 'AU': this.qmsservice.activity.auId, 'IN': this.qmsservice.activity.inId, 'QI': this.qmsservice.activity.qiId, 'CC': this.qmsservice.activity.ccId };

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(viewType: any, stage_user: any) {
    console.log(stage_user);
    this.message.tableOrView_Name = "ONEQMS_TASK_STAGE_USERS_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,USER_FULLNAME,USER_LEVEL,USER_NAME,USER_ROLE,MODULE,STAGE_NAME,STAGE_SEQ,STATUS,REASON_FOR_SIGNATURE,REF_DETAILS,REQUESTED_ON,COMPLETED_ON,LAST_REMINDER_SENT_ON,REJECT_REASON,COMMENTS,IS_ACTIVE,IS_CHECKLIST_ENABLED,IS_CHECKLIST_SKIPPED,DOC,DOC_EXTN,UPDATED_BY_USER,UPDATED_ON,DELETED_BY_USER,DELETED_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action,User Fullname,User Level,User Name,User Role,Module,Stage Name,Stage Seq,Status,Reason For Signature,Ref Details,Requested On,Completed On,Last Reminder Sent On,Reject Reason,Comments,Is Active,Is CheckList Enabled,Is CheckList Skipped,Documents,Documents Extension,Updated By,Updated On,Deleted By,Deleted Reason";
    this.message.whereClause_AU = " AND REF_NO=" + this.getIdMethod() +
      " AND STAGE_NAME='" + this.labelName + "'" +
      " AND MODULE='" + (this.currentUrl == '/dashboard/parallelworkflowDetails' ? 'PRL_WORKFLOW' : this.qmsservice.moduleName) + "'" + (viewType == 'individual' ?
        " AND USER_ID=" + stage_user.taskStageUsersPk.userId : '');

    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action,User Fullname,User Level,User Name,User Role,Module,Stage Name,Stage Seq,Status,Reason For Signature,Ref Details,Requested On,Completed On,Last Reminder Sent On,Reject Reason,Comments,Is Active,Is CheckList Enabled,Is CheckList Skipped,Documents,Documents Extension,Updated By,Updated On,Deleted By,Deleted Reason";
    this.message.whereClause_Report = " WHERE REF_NO=" + this.getIdMethod() +
      " AND STAGE_NAME='" + this.labelName + "'" +
      " AND MODULE='" + (this.currentUrl == '/dashboard/parallelworkflowDetails' ? 'PRL_WORKFLOW' : this.qmsservice.moduleName) + "'" + (viewType == 'individual' ?
        " AND USER_ID=" + stage_user.taskStageUsersPk.userId : '');
    this.message.report_And_Popup_Name = this.qmsservice.moduleName + ' ' + this.labelName + ' Audit Trail [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.staticAuditTrailComponent.triggerTrail(stage_user);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "ONEQMS_TASK_STAGE_USERS_VW";
    this.excelPdf.columnList_DB = "USER_FULLNAME,USER_LEVEL,USER_NAME,USER_ROLE,MODULE,STAGE_NAME,STAGE_SEQ,STATUS,REASON_FOR_SIGNATURE,REF_DETAILS,REQUESTED_ON,COMPLETED_ON,LAST_REMINDER_SENT_ON,REJECT_REASON,COMMENTS,IS_ACTIVE,IS_CHECKLIST_ENABLED,IS_CHECKLIST_SKIPPED,DOC_EXTN,UPDATED_BY_USER,UPDATED_ON";
    this.excelPdf.columnList_Report = "User Fullname,User Level,User Name,User Role,Module,Stage Name,Stage Seq,Status,Reason For Signature,Ref Details,Requested On,Completed On,Last Reminder Sent On,Reject Reason,Comments,Is Active,Is CheckList Enabled,Is CheckList Skipped,Documents Extension,Updated By,Updated On";
    this.excelPdf.whereClause_Report = " WHERE REF_NO=" + this.getIdMethod() +
      " AND STAGE_NAME='" + this.labelName + "'" +
      " AND MODULE='" + (this.currentUrl == '/dashboard/parallelworkflowDetails' ? 'PRL_WORKFLOW' : this.qmsservice.moduleName) + "'";
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = this.qmsservice.moduleName + ' ' + this.labelName + ' Report [' + this.idMapping[this.qmsservice.moduleName] + ']';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

  getAesthetic(x: any) {
    const module: string = this.qmsservice.moduleName;
    const isAU: boolean = module == 'AU';
    const isOOS: boolean = module == 'OOS';
    const isNotAUAndOOs: boolean = !isAU && !isOOS;
    const status: string = this.qmsservice.activity.status;
    const showButtons: boolean = this.message.showReviewApproveActionButtons;
    const elite: boolean = this.qmsservice.elite_AccessToClosure_Reviewer_Approver;
    const stage = x.stageName;
    const userId: number = +this.message.getUserId();
    const isClosure = stage == 'Closure Review' || stage == 'Closure Approve';

    const pwfStatus: string = this.qmsservice.parallelworkflowStatus;
    const owner: number = +this.qmsservice.activity.owner;
    const evaluator: number = +this.qmsservice.activity.evaluator;
    const isParallelWorkFlow: boolean = (pwfStatus == 'Draft' || pwfStatus == 'Review Rejected' || pwfStatus == 'Reviewer Requested More Info.') &&
      (((module == 'CR' || module == 'DV' || module == 'CAPA' || module == 'OOS') && (owner == userId)) ||
        ((module == 'IN' || module == 'QI' || module == 'CC') && (evaluator == userId)) ||
        (module == 'AU' && this.auService.isAuditor));

    const isSensitiveOOS: Set<any> = new Set(['Pending Data Evaluation', 'Department Head Review Requested More Info.', 'Department Head Review Rejected', 'QA Review Rejected', 'Closure Reviewer Requested More Info.', 'Closure Review Rejected', 'Closure Approver Requested More Info.', 'Closure Approval Rejected', 'In Progress', 'PhaseII In Progress', 'PhaseIII In Progress']);
    const isSensitiveAU: Set<any> = new Set(['Auditee Requested More Info.', 'Auditee Accepted', 'Findings In Progress']);
    const isInParallelPage: boolean = this.currentUrl == '/dashboard/parallelworkflowDetails';

    return (isAU && (
      (!isSensitiveAU.has(status) && showButtons) || (isSensitiveAU.has(status) && (elite && !showButtons && isClosure)) ||
      (status == 'Findings In Progress' && isParallelWorkFlow && isInParallelPage)))
      || (isOOS && (
        (!isSensitiveOOS.has(status) && showButtons) || (isSensitiveOOS.has(status) && (elite && !showButtons && isClosure)) || isParallelWorkFlow))
      || (isNotAUAndOOs && (
        (status != 'In Progress' && showButtons) ||
        (status == 'In Progress' && ((elite && !showButtons && isClosure) || isParallelWorkFlow)))
      )
  }

  @ViewChild('checkListPopup', { static: true }) checkListPopup: TemplateRef<any>;
  visibleCheckListPopup: MatDialogRef<TemplateRef<any>>;

  checkListPopupConfig = {
    width: '80%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  checkListFields: any = [];
  checkListTitle: string = '';
  dropDownSearchText: string = '';
  multiSelection: boolean = false;
  openCheckListPopup(stage: any, user: any): void {
    this.isProcessing = true;
    this.appService.getAllCheckList(this.qmsservice.activityId, stage.stageName, user.taskStageUsersPk.userId).subscribe((fields: any) => {

      fields.forEach((el: any) => {
        el.fieldValues = el.fieldValues?.split(',') ?? null;
        if (['Drop Down', 'Multiselect Drop Down', 'Vertical Checkbox Button', 'Horizontal Checkbox Button', 'Vertical Radio Button', 'Horizontal Radio Button'].includes(el.fieldTypeCode)) {
          el.dd = el.response ? el.response.split(',') : [];
        } else if (el.fieldTypeCode == 'Date Field') {
          el.response = el.response ? new Date(el.response) : null;
        }
      });
      this.isProcessing = false;
      this.checkListFields = fields?.sort((a: any, b: any) => a.fieldSeq - b.fieldSeq);
      if (this.checkListFields.length) {
        this.checkListTitle = stage.stageName + " CheckList";
        this.visibleCheckListPopup = this.dialog.open(this.checkListPopup, this.checkListPopupConfig);
      } else {
        this.showSnackBar('This user has performed checkList and skipped later', 'E');
      }

    });
  }

  cancelCheckListPopup() {
    this.visibleCheckListPopup.close();
  }

  dateCustomClasses: DatepickerDateCustomClasses[];

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  };

  public focusSearch(value: any): void {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus() }, 0)
  }

  snackbarRef: any;
  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  getStatusColor(status: string): string {
    if (status.includes('Rejected')) return 'red';
    if (status.includes('Approved')) return 'green';
    if (status.includes('Reviewed')) return 'green';
    if (status.includes('Requested More Info.')) return 'brown';
    return 'orange';
  }

}

